import React, { useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import DotSvg from '../../../svg/DotSvg';
import { setWholeFocusEvent, setWholeFocusNewsletter } from '../../../store/focuspage/focuspageSlice';
import CrossArrow from '../../../svg/CrossArrow';
import { deleteFocusNewsletterThunk, getDataForFocusThunk } from '../../../store/focuspage/focuspageThunk';
import Delete from '../../../svg/Delete';
import { setDeleteAlert } from '../../../store/alert/alertSlice';
import EditIcon from '../../../svg/EditSvg';

export default function NewsRedirectCard({ txt, link, dotimgclss, item, isDelete }) {
    const token = localStorage.getItem('dizeeToken');
    const dispatch = useDispatch();
    const navigate = useNavigate();

    useEffect(() => {
        dispatch(getDataForFocusThunk({ token: token }))
    }, [])

    const handleProductEditClick = () => {
        let newsletter = item.newsletter?.[0]
        navigate('/focus-page/newsletter-type/edit-content', {
            state: {
                newsletter,
                description: item?.description,
                extension: item?.extension
            }
        });
    }

    const handleProductEditClick1 = () => {
        navigate('/focus-page/newsletter-type/edit-multi-content', {
            state: {
                newsletter: item?.newsletter,
                description: item?.description,
                extension: item?.extension
            }
        });
    }

    return (
        <div className='p-4 py-6 flex w-full justify-between items-center'>
            <div className='flex items-center'>
                <span className='text-white'>{txt}</span>
                {dotimgclss && (

                    <DotSvg width={6} height={6} color={'red'} className='ml-2' />

                )}
            </div>
            <div className="flex flex-row items-center gap-x-[15px]">
                <button onClick={() => {
                    dispatch(setWholeFocusNewsletter(item))
                    navigate(link)
                }} >
                    <CrossArrow className='h-[14px] w-[14px]  cursor-pointer' />
                    {/* <img src={plus} alt='plus'  /> */}
                </button>
                <button onClick={() => {
                    if (link == '/focus-page/newsletter-page') {
                        handleProductEditClick()
                    } else {
                        handleProductEditClick1();
                    }
                }} >
                    <EditIcon className='h-[14px] w-[14px]  cursor-pointer' />
                </button>
                {
                    isDelete &&
                    <button onClick={() => {

                        dispatch(setDeleteAlert({
                            type: 'newsletter',
                            data: {
                                token, payload: {
                                    ...item
                                }
                            }
                        }));

                        // dispatch(deleteFocusNewsletterThunk({
                        //     token, payload: {
                        //         ...item
                        //     }
                        // }))
                    }} >
                        {/* <CrossArrow className='h-[14px] w-[14px]  cursor-pointer' /> */}
                        <Delete className='h-[14px] w-[14px]  cursor-pointer' />
                    </button>
                }
            </div>
        </div>
    );
}
